export const HOME_URL = '/admin';
export const GENERAL_URL = '/general';
export const USER_URL = '/user';
export const USERS_URL = '/users';
export const FEATURES_URL = '/feature-management';
export const ADMIN_URL = '/administrators';
export const APPLICATIONS_URL = '/applications';
export const APP_CREATE_URL = '/create-application';
export const ATTRIBUTES_URL = '/attributes';
export const DYNAMIC_PAGES_URL = '/pages';
export const PERSON_PROFILE_URL = '/person-profiles';
export const DIRECTORIES_URL = '/directories';
export const SOURCE_CREATE_URL = '/create-source';
export const SOURCE_URL = '/source';
export const DEBUG_URL = '/debug';
